import React, { useContext, useState, useEffect, FC } from "react";
import { Screen, FileSystem } from "./";

export const MiniBrowser: FC<any> = ({
  src,
  title,
  refrence,
  className,
  iFrameClassName,
  style,
  relativePath,
}) => {
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState<any>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const { refreshKey, theme } = useContext<any>(Screen.context);

  const { readFile, documentRefreshKey } = useContext<any>(FileSystem.context);

  if (theme === "dark") {
    // add theme=dark param to the src
    if (src.includes("?")) {
      src += "&theme=dark";
    } else {
      src += "?theme=dark";
    }
  }

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  useEffect(() => {
    if (relativePath) {
      (async () => {
        try {
          const file = await readFile(`.editor/${relativePath}`);
          if (file) {
            setFile(file);
          }
        } catch (error) {}
      })();
    }
    setLoading(false);
  }, [documentRefreshKey]);

  if (loading) {
    return <></>;
  }

  if (file) {
    return (
      <div
        className={`fit relative no-scrollbar ` + className}
        style={{ ...style }}
      >
        <iframe
          id="documentation"
          srcDoc={file}
          className={`fit no-scrollbar ${iFrameClassName}`}
          title={title}
          allowFullScreen
          allow="cross-origin-isolated; clipboard-read; clipboard-write; camera *; microphone *;"
          ref={refrence}
        />
      </div>
    );
  }

  return (
    <div
      className={`fit relative no-scrollbar ` + className}
      style={{ ...style }}
      key={refreshKey}
    >
      <iframe
        id="documentation"
        src={src}
        className={`fit no-scrollbar ${iFrameClassName}`}
        title={title}
        allowFullScreen
        allow="cross-origin-isolated; clipboard-read; clipboard-write; camera *; microphone *;"
        ref={(el) => {
          refrence.current = el;
          if (el) {
            el.addEventListener("load", handleIframeLoad);
          }
        }}
      />
    </div>
  );
};
